export default function ScrollToBottom() {
  let submitted = false

  const submittedInput = $('.c-sign-up__input--submitted')
  if (submittedInput.length > 0) {
    submitted = true
  }

  function onScroll() {
    window.scrollTo(0, document.body.scrollHeight)
    submitted = false
  }

  const init = () => {
    if (submitted) {
      onScroll()
    }
  }

  return {
    init: init,
  }
}
